import { orchestrator } from 'satcheljs';
import { onLocaleChanged } from 'owa-localize';
import { lazyNotifyWorkerLocaleChanged } from 'owa-data-worker-client';
import { getLocalizedStringStore } from 'owa-localize/lib/store/store';

orchestrator(onLocaleChanged, ({ locale }) => {
    const dir: 'ltr' | 'rtl' = document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';
    const { currentCulture } = getLocalizedStringStore();
    lazyNotifyWorkerLocaleChanged.importAndExecute(locale, dir, currentCulture);
});
